module.exports = __webpack_public_path__ + "img/image_link.956eb12b.svg";